import { jwtDecode } from "jwt-decode";
import { TokenDecrypt } from "../../Shared/Utils/encryptionDecryption";
import { loginFromServer } from "../../Services/AuthService";
import { toast } from "react-toastify";
import {
  errorToastStyle,
  successToastStyle,
} from "../../Shared/Utils/ToastUtils";
import { setSessionItemFunction } from "../../Shared/Utils/getAreaId";
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE"; // Corrected action type

export const login = (loginId, password, navigate) => {
  return async (dispatch) => {
    dispatch({ type: LOGIN });
    try {
      const encryptedData = await loginFromServer(loginId, password);
      setSessionItemFunction("entireToken", encryptedData);
      const loggedUserToken = TokenDecrypt(encryptedData);
      const state = loggedUserToken.stateName;
      const district = loggedUserToken.districtName;
      const districtId = loggedUserToken.districtId;
      const talukaId = loggedUserToken.talukaId;
      const stateId = loggedUserToken.stateId;
      const taluka = loggedUserToken.talukaName;
      const phcname = loggedUserToken.phcName;
      const subcenter = loggedUserToken.subcenterName;
      const phcId = loggedUserToken.phcId;
      const areaId = loggedUserToken.areaId;
      const accessMenus = loggedUserToken.accessMenus;
      const access_level_id = loggedUserToken.access_level_id;
      const corporation_council_id = loggedUserToken.corporation_council_id;
      const lgbId = loggedUserToken.lgbId;
      const incentive_role = loggedUserToken.incentive_role;
      const userCode = loggedUserToken.userCode;

      setSessionItemFunction("stateName", state);
      setSessionItemFunction("phcName", phcname);
      setSessionItemFunction("subcenterName", subcenter);
      setSessionItemFunction("districtId", districtId);
      setSessionItemFunction("stateId", stateId);
      setSessionItemFunction("talukaId", talukaId);
      setSessionItemFunction("districtName", district);
      setSessionItemFunction("talukaName", taluka);
      setSessionItemFunction("phcId", phcId);
      setSessionItemFunction("areaId", areaId);
      setSessionItemFunction("accessMenus", accessMenus);
      setSessionItemFunction("access_level_id", access_level_id)
      setSessionItemFunction("corporation_council_id",corporation_council_id)
      setSessionItemFunction("lgbId", lgbId)
      setSessionItemFunction("incentive_role",incentive_role)
      setSessionItemFunction("userCode",userCode)

      const refreshToken = loggedUserToken.refreshToken;
      const role = loggedUserToken.userRole;
      setSessionItemFunction("refreshToken", refreshToken);
      const idToken = loggedUserToken.idToken;
      setSessionItemFunction("userToken", idToken);
      const decodedidToken = jwtDecode(idToken);
      const usercode = decodedidToken["custom:Usercode"];
      setSessionItemFunction("userRole", role);
      dispatch({ type: LOGIN_SUCCESS, payload: { role, idToken, usercode } });
      //loggedUser,role,idToken,usercode
      toast.success("Login Successful", {
        style: successToastStyle,
      });
      window.location.href = "/dashboard";
    } catch (error) {
      dispatch({
        type: LOGIN_FAILURE,
        payload: (() => {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            return error.response.data.message;
          } else {
            return error && error.message
              ? error.message
              : "Unknown error occurred";
          }
        })(),
      });
      toast.error("Login Failed.", {
        style: errorToastStyle,
      });
    }
  };
};
